import type { SerializedCompStructure } from '@wix/document-services-types';

export const createResponsivePopupContainer = (): SerializedCompStructure => ({
  type: 'Container',
  layouts: {
    containerLayout: {
      type: 'GridContainerLayout',
      padding: {
        left: {
          type: 'px',
          value: 0,
        },
        right: {
          type: 'px',
          value: 0,
        },
        top: {
          type: 'px',
          value: 0,
        },
        bottom: {
          type: 'px',
          value: 0,
        },
      },
      rows: [
        {
          type: 'fr',
          value: 1,
        },
      ],
      columns: [
        {
          type: 'fr',
          value: 1,
        },
      ],
    },
    componentLayout: {
      minHeight: {
        type: 'px',
        value: 0,
      },
      height: {
        type: 'auto',
      },
      minWidth: {
        type: 'px',
        value: 0,
      },
      type: 'ComponentLayout',
      width: {
        type: 'maxContent',
      },
    },
    itemLayout: {
      type: 'FixedItemLayout',
      margins: {
        left: {
          type: 'px',
          value: 0,
        },
        right: {
          type: 'px',
          value: 0,
        },
        top: {
          type: 'px',
          value: 0,
        },
        bottom: {
          type: 'px',
          value: 0,
        },
      },
      justifySelf: 'center',
      alignSelf: 'center',
    },
    type: 'SingleLayoutData',
  },
  style: {
    type: 'ComponentStyle',
    style: {
      properties: {
        'alpha-bg': '1',
        bg: 'color_11',
      },
      propertiesSource: {
        'alpha-bg': 'value',
        bg: 'theme',
      },
      groups: {},
    },
    componentClassName: 'wysiwyg.viewer.components.PopupContainer',
    pageId: '',
    compId: '',
    styleType: 'custom',
    skin: 'wysiwyg.viewer.skins.screenwidthcontainer.ResponsivePopupContainerWithColorBG',
  },
  componentType: 'wysiwyg.viewer.components.PopupContainer',
  skin: 'wysiwyg.viewer.skins.screenwidthcontainer.ResponsivePopupContainerWithColorBG',
});

export const createPopupContainer = ({
  width,
  height,
}: {
  width: number;
  height: number;
}): SerializedCompStructure => ({
  type: 'Container',
  layout: {
    width,
    height,
    x: 0,
    y: 0,
  },
  componentType: 'wysiwyg.viewer.components.PopupContainer',
});
